import { produce } from 'immer'

import { Redux } from 'types/local'
import { Enum } from 'types/enum'
import { gamesActions } from './games.actions'

const { types } = gamesActions

export type State = Redux.UserState['games']
export const initialState: State = {
  isLoading: false,
  games: [],
}
export const gamesReducer = produce((state: State, action: Redux.Action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case types.GET_GAMES.REQUEST:
      state.isLoading = true
      break
    case types.GET_GAMES.SUCCESS:
      state.isLoading = false
      state.games = action.payload
      break
    case types.GET_GAMES.FAILED:
      state.isLoading = false
      break
  }
}, initialState)
